<template>
    <div>
        <section id="contact_us" ref="toolbarChat" class="blockElement banner">
            <div class="container" align="center">
                <div class="banner_text text-center">
                    <h1 class="m-0"><span>Contact</span> Us!</h1>
                    <p>We look forward to assist you.</p>
                </div>
            </div>
        </section>
        <section id="selectContact" class="blockElement contactForm pt-0">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-12 col-lg-6">
                        <div class="bottom-shadow whiteBoard">
                            <div class="head-title text-center">
                                <h2>Send Us A <span>Message </span></h2>
                            </div>
                            <div>
                                <appgetinTouch></appgetinTouch>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="blockElement customTabing" id="callSupport">
            <div class="container" align="center">
                <div class="row">
                    <div class="col-12">
                        <ul class="tabs nav nav-tabs" id="myTab">
                            <li class="nav-item" :id="tab.name" v-for="tab in tabs" @click.prevent="setActiveTabName(tab.name)">
                                <a class="nav-link" href="#" v-bind:class="(tab.name == activeTabName)?'active':''">{{ tab.displayName }}</a>
                            </li>
                        </ul>
                        <div class="tab_container tab-content hideMob-t" id="myTabContent">
                            <h3 class="d_active tab_drawer_heading" rel="tab1" @click.prevent="setActiveTabName('overview')" v-bind:class="(activeTabName == 'overview')?'active':''">Phone Support</h3>
                            <div id="tab1" class="tab_content" v-if="(activeTabName == 'overview')">
                                <ul align="left" class="contactBlock d-flex">
                                    <li>
                                        <span><phone-call-icon size="1.5x" class="custom-class"></phone-call-icon></span> <strong>Business: <br></strong>
                                        <a style="font-size: 14px;" href="tel:+911726670000"> +91 1726 670 000 </a>
                                    </li>
                                    <li>
                                        <span><phone-call-icon size="1.5x" class="custom-class"></phone-call-icon></span>
                                        <strong>Client Support:</strong> 
                                        <p style="font-size: 14px;" class="mb-0">New Numbers:</p>
                                        <div class="d-flex justify-content-center flex-wrap">
                                            <a style="padding-right: 2px;font-size: 12px;" href="tel:+919779902002">+91 9779 902 002 |</a> 
                                            <a  style="font-size: 12px;" href="tel:+918699987666">+91 8699 987 666 (Call & Trade)</a>
                                        </div>
                                    </li>
                                    <li>
                                        <span><phone-call-icon size="1.5x" class="custom-class"></phone-call-icon></span> <strong>Sales(New Account Assistance): </strong><br>
                                        <p style="font-size: 14px;" class="mb-0">New Number:</p>
                                        <div class="d-flex justify-content-center flex-wrap">
                                            <a style="padding-right: 2px;font-size: 12px;" href="tel:+918288826999">+91 8288 826 999</a> 
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <!-- #tab1 -->
                            <h3 class="tab_drawer_heading" rel="tab2" @click.prevent="setActiveTabName('about')" v-bind:class="(activeTabName == 'about')?'active':''">Compliance</h3>
                            <div id="tab2" class="tab_content" v-if="(activeTabName == 'about')">
                                <ul align="left" class="contactBlock2 pt-3">
                                    <li><span>NSE/BSE/MCX/NCDEX:</span>Hardeep Singh: ccofspl (at) shoonya.com</li>
                                    <li><span>CDSL DP: </span>Hardeep Singh: ccodp (at) shoonya.com</li> 
                                    <li><span>SEC</span>S Singh :- ssingh (at) shoonya.com</li>
                                    <li><span>FII</span>S Singh :- cco (at) shoonya.com</li> 
                                </ul>
                            </div>
                            <!-- #tab2 -->
                            <h3 class="tab_drawer_heading" rel="tab3" @click.prevent="setActiveTabName('check')" v-bind:class="(activeTabName == 'check')?'active':''">Online Support</h3>
                            <div id="tab3" class="tab_content" v-if="(activeTabName == 'check')">
                                <ul align="left" class="contactBlock d-flex">
                                    <li>
                                        <span><mail-icon size="1.5x" class="custom-class"></mail-icon></span><a href="mailto:contactus@shoonya.com ">contactus@shoonya.com </a>
                                    </li>
                                    <li>
                                        <span><mail-icon size="1.5x" class="custom-class"></mail-icon></span><a href="mailto:clientsupport@shoonya.com"> clientsupport@shoonya.com</a>
                                    </li>
                                    <li>
                                        <span><message-circle-icon size="1.5x" class="custom-class"></message-circle-icon></span>Active Online Support: <a href="https://direct.lc.chat/13534029/3" target="_blank">Live Chat</a>
                                    </li>
                                </ul>
                            </div>
                            <!-- #tab3 -->
                            <h3 class="tab_drawer_heading" rel="tab4" @click.prevent="setActiveTabName('fin')" v-bind:class="(activeTabName == 'fin')?'active':''">Important Emails</h3>
                            <div id="tab4" class="tab_content" v-if="(activeTabName == 'fin')">
                                <ul align="left" class="contactBlock2 pt-3">
                                    <li><span> Any Complaint</span> complaints (at) shoonya.com</li>
                                    <li><span> General Information</span> info (at) shoonya.com</li>
                                    <li><span> CDSL DP</span> cdspdp (at) shoonya.com</li> 
                                    <!-- <li><span> Suggestions</span> suggestions (at) shoonya.com</li> -->
                                    <li><span>Sales</span> sales (at) shoonya.com</li> 
                                    <li><span> Trading</span> trading (at) shoonya.com</li>
                                    <li><span> Foreign Investors</span> fiienquiry (at) shoonya.com</li>
                                </ul>
                            </div>
                            <h3 class="tab_drawer_heading" rel="tab5" @click.prevent="setActiveTabName('matrix')" v-bind:class="(activeTabName == 'matrix')?'active':''">Escalation Matrix</h3>
                            <div id="tab5" class="tab_content py-4 text-left" v-if="(activeTabName == 'matrix')">
                                <div class=" finTable position-relative">
                                <h3 class="t3 text-left pl-3 mb-0">Escalation Matrix Of Investor Grievance For Broking & Depository Services</h3>
                                    <div class="table-responsive pb-3">
                                        <table class="table table-striped matrixTable border">
                                                <thead>
                                                    <tr>
                                                        <th>Details </th>
                                                        <th>Contact Person</th>
                                                        <th>Address</th>
                                                        <th width="150">Contact No.</th>
                                                        <th>Email Id</th>
                                                        <th>Working Hours</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>Customer Care</td>
                                                        <td>Adity Chhiba</td>
                                                        <td>D- 179, Phase- 8B (sector 74), Industrial Area, Mohali, Punjab- 160055</td>
                                                        <td width="150"><a href="tel:0172-667">0172-6670000/1444</a></td>
                                                        <td><a href="mailto:clientsupport@shoonya.com">clientsupport@shoonya.com</a></td>
                                                        <td>9:30 am to 6:30 pm</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Head of Customer Care</td>
                                                        <td>Kapil Abrol</td>
                                                        <td>D- 179, Phase- 8B (sector 74), Industrial Area, Mohali, Punjab- 160055</td>
                                                        <td width="150"><a href="tel:0172-6670000">0172-6670000/418</a></td>
                                                        <td><a href="mailto:hocs@shoonya.com">hocs@shoonya.com</a></td>
                                                        <td>9:30 am to 6:30 pm</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Compliance Officer</td>
                                                        <td>Hardeep Singh</td>
                                                        <td>D- 179, Phase- 8B (sector 74), Industrial Area, Mohali, Punjab- 160055</td>
                                                        <td width="150"><a href="tel:0172-6670000">0172-6670000/1509</a></td>
                                                        <td><a href="mailto:complaints@shoonya.com">complaints@shoonya.com</a></td>
                                                        <td>10:00 am to 6:00 pm</td>
                                                    </tr>
                                                    <tr>
                                                        <td>CEO</td>
                                                        <td>Sarvjeet Singh</td>
                                                        <td>D- 179, Phase- 8B (sector 74), Industrial Area, Mohali, Punjab- 160055</td>
                                                        <td width="150"><a href="tel:0172-6670000">0172-6670000</a></td>
                                                        <td><a href="mailto:ccofspl@shoonya.com">ccofspl@shoonya.com</a></td>
                                                        <td>11:00 am to 5:50 pm</td> 
                                                    </tr>
                                                </tbody>
                                        </table>
                                    </div>
                                </div>
                                <p>In absence of response/complaint not addressed to your satisfaction, You can also file a complaint with the appropriate regulators <br><br>
                                    SEBI- <a href="https://scores.sebi.gov.in" target="_blank">https://scores.sebi.gov.in</a> <br>
                                    NSE- <a href="https://investorhelpline.nseindia.com/NICEPLUS" target="_blank">https://investorhelpline.nseindia.com/NICEPLUS</a><br>
                                    BSE- <a href="https://bsecrs.bseindia.com/ecomplaint/frmInvestorHome.aspx" target="_blank">https://bsecrs.bseindia.com/ecomplaint/frmInvestorHome.aspx</a><br>
                                    MCX- <a href="https://www.mcxindia.com/Investor-Services" target="_blank">https://www.mcxindia.com/Investor-Services</a><br>
                                    NCDEX- <a href="https://ncdex.com/investor_complaint" target="_blank">https://ncdex.com/investor_complaint</a><br>
                                    CDSL- <a href="https://www.cdslindia.com/Footer/grievances.aspx" target="_blank">https://www.cdslindia.com/Footer/grievances.aspx</a><br>
                                </p>
                                <p>Please quote your Service Ticket/Complaint Ref No. while raising your complaint at SEBI SCORES/Exchange portal.</p>
                            </div>
                            <h3 class="tab_drawer_heading" rel="tab6" @click.prevent="setActiveTabName('kmp')" v-bind:class="(activeTabName == 'kmp')?'active':''">KMP Details</h3>
                            <div id="tab6" class="tab_content py-4 text-left" v-if="(activeTabName == 'kmp')">
                                <div class=" finTable position-relative">
                                <h3 class="t3 text-left pl-3 mb-0">Names and contact details of all Key Managerial Personnel including the Compliance Officer</h3>
                                    <div class="table-responsive pb-3">
                                        <table class="table table-striped matrixTable border">
                                                <thead>
                                                    <tr>
                                                        <th>Sr.No. </th>
                                                        <th>Name of the Individual</th>
                                                        <th>Designation</th>
                                                        <th width="150">Mobile Number</th>
                                                        <th>Email Id</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr>
                                                        <td>1</td>
                                                        <td>Sarvjeet Singh</td>
                                                        <td>MD/CEO</td>
                                                        <td width="180"><a href="tel:+917087404840">+91 7087 404 840</a></td>
                                                        <td><a href="mailto:ss@shoonya.com">ss@shoonya.com</a></td>
                                                    </tr>
                                                    <tr>
                                                        <td>2</td>
                                                        <td>Ramneek</td>
                                                        <td>Director</td>
                                                        <td width="150"><a href="tel:+917087031480">+91 7087 031 480</a></td>
                                                        <td><a href="mailto:rk@shoonya.com">rk@shoonya.com</a></td>
                                                    </tr>
                                                    <tr>
                                                        <td>3</td>
                                                        <td>Hardeep Singh</td>
                                                        <td>Compliance officer</td>
                                                        <td width="150"><a href="tel:+918288026102">+91 8288 026 102</a></td>
                                                        <td><a href="mailto:complaints@shoonya.com">complaints@shoonya.com</a></td>
                                                    </tr>
                                                </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="blockElement customAccordion office_location pt-5 wtx ">
            <div class="container" align="center">
                <div class="head-title text-center">
                    <h2><span>Office </span>Location</h2>
                </div>
                <div class="row justify-content-center">
                    <div class="col-12 col-lg-10">
                        <div class="bottom-shadow whiteBoard">
                            <div class="row">
                                <div class="col-12 col-md-6 col-sm-12 accordion downloadpageaccordion">
                                    <div v-for="(value, key) in myItems">
                                        <div class="accordion__item"> 
                                            <div class="accordion__title d-flex align-items-center justify-content-between"  @click="detailDiv(key);"  >
                                                <p class="accordion__title-text">{{value.title}}</p>
                                                <plus-icon class="plusicon"></plus-icon>
                                            </div>
                                        </div>
                                        <div v-show="selectedIndex == key"> 
                                           <div class="card-body cp-pad text-left"  v-html="value.detail">
                                           </div> 
                                        </div> 
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 col-sm-12">
                                    <iframe
                                        :src="myItems[selectedIndex].src"
                                        width="100%"
                                        height="330"
                                        frameborder="0"
                                        style="border: 0;"
                                        allowfullscreen=""  
                                    ></iframe>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <app-seo></app-seo>
        </section>
    </div>
</template>
<script src="https://unpkg.com/vue-recaptcha@latest/dist/vue-recaptcha.js"></script>
    <script src="https://unpkg.com/vue@latest/dist/vue.js" defer></script>
    <script>
        import VueRecaptcha from 'vue-recaptcha';
    
        import { MinusIcon, MailIcon, MessageCircleIcon, PhoneCallIcon, PlusIcon   } from 'vue-feather-icons'
        import SEO from '../shared/SEO'
        import VueFaqAccordion from 'vue-faq-accordion'
        import getinTouch from '../shared/contactform/getintouch' 
        import * as types from '@/types'
        import { mapActions } from 'vuex' 
    
        export default {
            name: 'Investment',
            data() {
                return {
                    name : "",
                    email: "",
                    errorName : "",
                    errorEmail : "",
                    errorMessage : "",
                    send_message : "",
                    dataKey: "",
                    myItems: {
                        'India' :{ 
                            title: 'India', 
                            'src': 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3430.3216520742903!2d76.6833081144609!3d30.70935669381123!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390f9321b2588017%3A0x38004d6e9981bd1c!2sFINVASIA!5e0!3m2!1sen!2sin!4v1583144504578!5m2!1sen!2sin',
                            detail : 'Head Office:  <br> Plot No D-179 Finvasia Centre Phase 8b Industrial <br> Area G F Sector 74<br>Sas Nagar Mohali<br>Mohali 160054<br>Punjab <br> <br>Corporate Office:  <br> 1505, 15th Floor, B Wing,  <br> One BKC, G Block, <br>Bandra Kurla Complex, <br>Mumbai<br>Maharashtra' 
                        },
                        'United Kingdom' :{ 
                            title: 'United Kingdom',
                            'src' : 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2484.0120870100227!2d-0.27780198423048746!3d51.49464567963305!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x48760e0ca49e2cd7%3A0xaaa5d2a5f706f1d8!2s3%2C%20Chiswick%20Park%2C%20566%20Chiswick%20High%20Rd%2C%20Chiswick%2C%20London%20W4%205YA%2C%20UK!5e0!3m2!1sen!2sin!4v1609825828026!5m2!1sen!2sin',
                            detail: 'Building # 3, <br>566 Chiswick High Road, London, W4 5YA<br> Tel. Phone: <a href="tel:+442032893467"> +442032893467</a>'
                        },

                        'Canada' :{ 
                            title: 'Canada', 
                            'src':'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2886.040444068393!2d-79.67130018450177!3d43.66812867912071!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x882b3edf1b24a587%3A0xe3b2a58231022053!2s10-6740%20Davand%20Dr%2C%20Mississauga%2C%20ON%20L5T%202K9%2C%20Canada!5e0!3m2!1sen!2sin!4v1609825898068!5m2!1sen!2sin',
                            detail : '6740 Davand Drive, Unit #10 <br> Mississauga, ON,Canada L5T 2K9 <br> Tel. Phone:<a href="tel:+16476945935"> +16476945935</a> ' 
                         },
                        
                        'Cyprus' :{ 
                            title: 'Cyprus', 
                            'src':'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d104977.07284491244!2d32.97172424266329!3d34.69172081601139!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x85bea665256d1a1a!2sKanika%20International%20Business%20Center!5e0!3m2!1sen!2sin!4v1609825965233!5m2!1sen!2sin',
                            detail: '319, 28th October Street, <br> Kanika Business Center, <br>Office 201B, 3105, <br> Limassol, Cyprus. <br> Tel. Phone:<a href="tel:+35725251100"> +357 2525-1100</a> ' 
                        },
                    },
                    tabs: [
                        {
                        name: 'overview',
                        displayName: 'Phone Support',
                        },
                        {
                        name: 'about',
                        displayName: 'Compliance',
                        },
                        {
                        name: 'check',
                        displayName: 'Online Support',
                        },
                        {
                        name: 'fin',
                        displayName: 'Important Emails',
                        },
                        {
                        name: 'matrix',
                        displayName: 'Escalation Matrix',
                        },
                        {
                        name: 'kmp',
                        displayName: 'KMP Details',
                        }
                    ],
                    activeTabName: null,
                    selectedIndex: 'India',
                }
            },
            components: {
                MinusIcon,
                MessageCircleIcon,
                MailIcon,
                PhoneCallIcon,
                VueFaqAccordion,
                appSeo: SEO,
                VueRecaptcha,
                appgetinTouch: getinTouch,
                PlusIcon 
            },
             methods: {
                detailDiv(getValue){
                    this.selectedIndex = getValue
                },

                setActiveTabName(name) {
                    this.activeTabName = name;
                },
                ...mapActions({
                    _runContactUs: types.RUN_CONTACT_US
                }),
                contact_us(){
                    
                    this.errorName = ""
                    this.errorEmail = ""
                    this.errorMessage = ""

                    if(this.name == ""){                        
                        this.errorName = "Please Enter name"
                    }
                    if(this.email != "" && this.send_message != ""){
                        this._runContactUs({
                            "name": this.name.trim(),
                            "email": this.email.trim(),
                            "message": this.send_message.trim(),
                            "parameter" : this
                        })
                    }if(this.email == ""){                        
                        this.errorEmail = "Please Enter Email"                        
                    }if(this.send_message == ""){                        
                        this.errorMessage = "Please Enter Message"
                    }
                },
                customValidation(getData){                    
                    if(getData != ''){  
                        const email = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                        if(!(getData.trim().match(email))){
                            this.errorEmail = 'Please Enter Valid Email'
                        }else{this.errorEmail = ''}
                    }
                },
    
    
                injectScript(params){
                    let script_injector = document.createElement('script');
                    script_injector.setAttribute('src', 'https://www.google.com/recaptcha/api.js');
                    script_injector.async = false;
                    script_injector.defer = false;
                    document.head.appendChild(script_injector)
                }
            },
            created(){
                this.activeTabName = this.tabs[0].name;

            },
            mounted() {
                //window.scroll(0,0)
                if(this.$route.params.page && this.$route.params.page == 'call'){
                    document.getElementById("overview").scrollIntoView();
                }else{
                    this.$refs.toolbarChat.scrollTop = 0;
                    //document.getElementById("selectContact").scrollIntoView();
                }
                this.injectScript()
            }
        }
    </script>
   <style scoped>
    .customTabing li.nav-item{
        width: calc(100% / 6);
    }
    </style>









// WEBPACK FOOTER //
// src/components/website/contact/contact_us.vue